export default __webpack_public_path__ + "images/matic_765bd4.svg";